import Vue from 'vue';
import { DirectDebitFile } from '@accounting/interfaces/direct-debit-file';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import Input from '@shared/components/forms/inputs/input/input.vue';
import RadioGroup from '@shared/components/forms/inputs/radio-group/radio-group.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';

@Component({
  name: 'bc-reject-direct-debit-file-item-modal',
  components: {
    'bpc-input': Input,
    'bpc-radio-group': RadioGroup,
    'bc-textarea': Textarea,
  },
})
export default class TicketToDirectDebitFileModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'ticket-direct-debit-file-modal' })
  readonly modalId: string;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedItemIds: number[];
  @Prop({
    type: String,
    default: 'global.generic.error_form_action',
  })
  readonly errorMessageText: string;
  @Prop({ type: Boolean, default: false }) readonly bulkReject: boolean;
  @Prop({ type: Number, default: 0 }) readonly elementToRejectId: number;
  @Prop({ type: Array, default: () => [] }) readonly elementsToRejectIds: number[];
  @Prop({ type: Boolean }) readonly value: boolean;

  loading: boolean = false;
  selectedDirectDebitFiles: DirectDebitFile = null;
  directDebitFiles: DirectDebitFile[] = [];
  requestSent: boolean = false;
  isProcessing: boolean = false;
  eventsSuccess = [];
  showErrors = false;
  errorsToShow = [];
  comment: string = '';

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get invoiceCommentLabel() {
    return this.$t('invoice.comment.label');
  }

  // LIFECYCLE
  mounted() {
    this.showErrors = false;
    if (this.showModal) {
      this.openModal();
    }
  }

  // METHODS
  onConfirm() {
    this.showErrors = false;
    this.isProcessing = true;
    if (this.bulkReject) {
      const sessionCode = this.getSessionCode();
      this.listenToWebsocketdirectDebitFileItemsUpdatedChannel(sessionCode);
      const path = `${this.$bpcApiRouteHelper.getEntityPath(
        'direct-debit-file-items',
      )}/bulk-reject`;
      this.$bpcApi
        .post(path, {
          directDebitFileItemIds: this.elementsToRejectIds,
          session_code: sessionCode,
          comment: this.comment,
        })
        .subscribe();
    } else {
      const path = `${this.$bpcApiRouteHelper.getEntityPath('direct-debit-file-items')}/${
        this.elementToRejectId
      }/reject`;
      this.$bpcApi
        .post(path, {
          comment: this.comment,
        })
        .subscribe(
          res => {
            this.$emit('direct-debit-file-items-rejected');
            this.isProcessing = false;
          },
          error => {
            console.log('error');
          },
        );
    }
  }

  listenToWebsocketdirectDebitFileItemsUpdatedChannel(sessionCode) {
    this.isProcessing = true;
    this.$bpcEcho
      .getDirectDebitFileItemsUpdatedChannel(sessionCode)
      .listen('.BPC\\Accounting\\Events\\DirectDebitFileItemsMarkedAsConfirmed', async data => {
        this.$bpcEcho.leaveDirectDebitFileItemsUpdatedChannel(sessionCode);
        this.isProcessing = false;
        this.$emit('direct-debit-file-items-rejected');
      })
      .listen('.BPC\\Accounting\\Events\\DirectDebitFileItemsMarkedAsRejected', async data => {
        this.$bpcEcho.leaveDirectDebitFileItemsUpdatedChannel(sessionCode);
        this.isProcessing = false;
        this.$emit('direct-debit-file-items-rejected');
      })
      .listen('.BPC\\Accounting\\Events\\GlobalErrorDirectDebitFileItemsUpdated', data => {
        this.$bpcMessage.showErrorMessage({
          text: data.msg,
        });
        this.$bpcEcho.leaveDirectDebitFileItemsUpdatedChannel(sessionCode);
        this.isProcessing = false;
      });
  }

  getSessionCode() {
    return `export-direct-debit-file-${this.tenantId}-${this.generateUUIDv4()}`;
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  get showModal(): boolean {
    return this.value;
  }
  set showModal(val: boolean) {
    this.$emit('input', val);
  }

  closeModal() {
    this.showErrors = false;
    this.showModal = false;
  }

  openModal() {
    this.showErrors = false;
    this.$bvModal.show(this.modalId);
  }

  resetModal() {
    this.comment = '';
    this.isProcessing = false;
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.resetModal();
    }
  }
}
